import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui-next/Paper";

import { DatePicker, Loadable } from "components/support";

import Moment from "moment";

class SalesmanSalesReportFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dateFrom: props.filters.dateFrom,
      dateTo: props.filters.dateTo,
      closeWorkaround: false
    };
  }

  static sReportTypes = [{ value: "summary", label: "Todos" }];

  handleChange = ({ startDate, endDate, reportType }) => {
    const { onChange } = this.props;
    const options = {};

    if (startDate) {
      options.dateFrom = Moment(startDate);
    }

    if (endDate) {
      options.dateTo = Moment(endDate);
    }

    this.setState(options);

    if (reportType) {
      onChange({ reportType });
    }
  };

  handleClose = () => {
    const { onChange } = this.props;
    this.setState({ closeWorkaround: !this.state.closeWorkaround }, () => {
      onChange({
        dateFrom: this.state.dateFrom,
        dateTo: this.state.dateTo
      });
    });
  };

  render() {
    const { loading } = this.props;
    const { dateFrom, dateTo } = this.state;

    return (
      <Paper elevation={1} className="p-sm mb-md">
        <Loadable loading={loading}>
          <Row>
            <Col xs={12}>
              <DatePicker
                multiple
                label="Período"
                modal
                fullWidth
                startDate={dateFrom}
                endDate={dateTo}
                onChange={({ startDate, endDate }) =>
                  this.handleChange({ startDate, endDate })
                }
                onClose={this.handleClose}
              />
            </Col>
          </Row>
        </Loadable>
      </Paper>
    );
  }
}

export default SalesmanSalesReportFilter;



// WEBPACK FOOTER //
// ./src/components/app/management/hour-sales-report/filter/index.jsx